import { requestBuilder } from '../../../http/RequestBuilder';

// From synctera-v0
export enum PatchPaymentScheduleStatus {
    CANCELLED = 'CANCELLED',
}

interface UpdatePaymentScheduleResponse {
    status: string;
}

interface UpdatePaymentScheduleURLParams {
    paymentScheduleId: string;
}

const useCancelPaymentSchedule = requestBuilder.mutation<
    UpdatePaymentScheduleResponse,
    undefined,
    UpdatePaymentScheduleURLParams
>({
    endpoint: ({ paymentScheduleId }) =>
        `/api/admin/banking/payment-schedule/cancel/${paymentScheduleId}`,
    method: 'PATCH',
});

export default useCancelPaymentSchedule;
